import { useEffect, useState } from 'react';

import { DictionariesEnum } from 'app/shared/enums';
import { Dictionary, DictService } from 'app/services/dict.service';
import { reportMessage } from 'app/services/errorReporter.service';

export function useDictionary(dictionaryName: string | DictionariesEnum) {
  const [dictEntries, setDictionary] = useState<Dictionary>([]);

  useEffect(() => {
    const fetchDict = () => {
      DictService.getDictionary(dictionaryName)
        .then(({ data }) => {
          setDictionary(data);
        })
        .catch((e) => {
          reportMessage(`DictService.getDictionary ${dictionaryName}, ${e}`);
        });
    };
    fetchDict();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return dictEntries;
}
